import { setGradeReportConfig } from '@conceptwaves/shared-components';
import BaseConfig from './config';

/**
 * Initialize shared components with iLearn-specific configuration
 * This should be called once during app startup (e.g., in index.js or App.js)
 */
export function initializeSharedComponents() {
  setGradeReportConfig({
    nodeSiteUrl: BaseConfig.nodeSiteUrl
  });

  console.log('[iLearn] Shared components initialized with config:', {
    nodeSiteUrl: BaseConfig.nodeSiteUrl
  });
}
